const StageField = ({
  formDataUser,
  handleChange,
  editable,
}) => {
  return (
    <div className="mt-4">
      <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
        ¿En qué etapa te encuentras?<span className="text-red-700"> *</span>
      </label>
      <select
        name="stage"
        value={formDataUser.stage}
        onChange={handleChange}
        disabled={!editable}
        className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
        required
      >
        <option value="">Selecciona una opción</option>
        <option value="Profesional">Profesional</option>
        <option value="Estudiante">Estudiante</option>
      </select>
    </div>
  );
};

export default StageField;
